import { IAttachment } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/AttachmentsStep';
import { IPaginator } from './paginator';

export enum ApplicationStatus {
  NewApplication = 'NEW_APPLICATION',
  Drafting = 'DRAFTING',
  Submitted = 'SUBMITTED',
  Assessment = 'ASSESSMENT',
  ActionRequired = 'ACTION_REQUIRED',
  Approved = 'APPROVED',
  Denied = 'DENIED',
}

export interface IApplicationBodyRequest {
  request: object;
  attachments: IAttachment[];
}

export interface IApplicationAttachment {
  uuid: string;
  name: string;
  type: string;
  createdDate: string;
  size: number;
  file: string[];
}

export interface IApplication {
  uuid: string;
  name: string;
  data: string;
  isDraft: boolean;
  status: ApplicationStatus;
  attachments: IApplicationAttachment[];
  createdBy: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
}

export interface IApplicationResponse extends IPaginator {
  content: IApplication[];
}

export interface IConversation {
  id: string;
  date: string;
  userName: string;
  comment: string;
}
